// components/Button.tsx
import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost" | "destructive" | "warning" | "success" | "empty";
  isOutlined?: boolean;
  size?: "xs" | "sm" | "md" | "lg";
}

export const Button: React.FC<ButtonProps> = ({ 
  variant = "primary",
  size = "md", 
  className = "", 
  isOutlined="", 
  ...props 
}) => {
  const base = "rounded transition-colors";
  const variants: Record<string, string> = {
    primary: (isOutlined ? "bg-white text-blue-500 border border-blue-500 hover:bg-blue-500 hover:text-white" : "bg-blue-500 text-white hover:bg-blue-600"),
    secondary: (isOutlined ? "bg-white text-gray-800 border border-gray-800 hover:bg-gray-800 hover:text-white" : "bg-gray-200 text-gray-800 hover:bg-gray-300"),
    ghost: "bg-transparent text-gray-600 hover:bg-gray-200",
    destructive: (isOutlined ? "bg-white text-red-500 border border-red-500 hover:bg-red-500 hover:text-white" : "bg-red-500 text-white hover:bg-red-600"),
    edit: (isOutlined ? "bg-white text-yellow-500 border border-yellow-500 hover:bg-yellow-500 hover:text-white" : "bg-yellow-500 text-white hover:bg-yellow-600"),
    warning: (isOutlined ? "bg-white text-yellow-500 border border-yellow-500 hover:bg-yellow-500 hover:text-white" : "bg-yellow-500 text-white hover:bg-yellow-600"),
    add: (isOutlined ? "bg-white text-green-500 border border-green-500 hover:bg-green-500 hover:text-white" : "bg-green-500 text-white hover:bg-green-600"),
    success: (isOutlined ? "bg-white text-green-500 border border-green-500 hover:bg-green-500 hover:text-white" : "bg-green-500 text-white hover:bg-green-600"),
    empty: "",
  };
  const sizes: Record<string, string> = {
    xs: "text-xs font-small px-2 py-1",
    sm: "text-sm font-medium px-3 py-1",
    md: "text-md font-medium px-3 py-1",
    lg: "text-lg font-medium px-3 py-1",
  };
  const disabled = (props.disabled ? "opacity-50 cursor-not-allowed" : "");

  return (
    <button className={`${base} ${variants[variant]} ${sizes[size]} ${disabled} ${className}`} {...props} />
  );
};
